import { getDiscountTotalWithoutShippingCoupon } from '@cart-services/core/cartService'
import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { ButtonFooterAmount } from '@cart-ui/ButtonFooterAmount/ButtonFooterAmount'
import { useDialog } from '@dni-hooks/useDialog'
import { useStmCart } from '../../cart/CartProvider'
import { DialogOrderDetail, DIALOG_ORDER_DETAIL, type DialogOrderDetailProps } from '../../cart/components/DialogOrderDetail'

export const CartFooterDetail = () => {
  const { campaignId, campaignCode, currency } = useStmCart()
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, Platform.STM)
  const { openDialog } = useDialog<DialogOrderDetailProps>(DIALOG_ORDER_DETAIL)
  const discountTotalWithoutShippingCoupon = getDiscountTotalWithoutShippingCoupon(calculateResult?.discount_items || [])

  return (
    <>
      <ButtonFooterAmount
        currency={currency || 'TWD'}
        amount={calculateResult?.total}
        shippingFee={calculateResult?.shipping_total}
        discountTotalWithoutShippingCoupon={discountTotalWithoutShippingCoupon}
        onClick={() => openDialog({ initialCampaignCode: campaignCode })}
      />
      <DialogOrderDetail />
    </>
  )
}
